import DashboardIcon from '@mui/icons-material/Dashboard'
import SquareIcon from '@mui/icons-material/Square'
import Grid from '@mui/material/Grid2'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { useFormik } from 'formik'
import { map } from 'lodash'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

export const MeetsFilter = ({ projectList }) => {
    const [searchParams, setSearchParams] = useSearchParams()

    const formik = useFormik({
        initialValues: {
            workplaceId: searchParams.get('workplaceId') ?? 0,
        },
    })

    useEffect(() => {
        searchParams.set('offset', '0')
        if (formik.values.workplaceId !== 0) {
            searchParams.set('workplaceId', formik.values.workplaceId)
            setSearchParams(searchParams)
        } else {
            searchParams.delete('workplaceId')
            setSearchParams(searchParams)
        }
    }, [formik.values.workplaceId])

    return (
        <Grid
            sx={{
                display: 'flex',
                width: '100%',
                alignItems: 'center',
            }}>
            <Typography variant="caption2" sx={{ mr: 0, whiteSpace: 'nowrap' }}>
                По проекту:
            </Typography>
            <TextField
                fullWidth
                color="info"
                slotProps={{
                    input: {
                        disableUnderline: true,
                    },
                }}
                sx={{
                    maxWidth: '200px',
                    border: 'none',
                    '& fieldset': { border: 'none' },
                    '& .MuiSelect-select': {
                        display: 'flex',
                        alignItems: 'center',
                    },
                }}
                select
                id="workplaceId"
                name="workplaceId"
                value={formik.values.workplaceId}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}>
                {map([{ id: 0, title: 'Показать все' }, ...projectList], (item) => {
                    return (
                        <MenuItem key={item.id} value={item.id}>
                            <Typography
                                sx={{
                                    maxWidth: '128px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    fontSize: '12px',
                                }}
                                variant="h6">
                                {item.title}
                            </Typography>
                        </MenuItem>
                    )
                })}
            </TextField>
        </Grid>
    )
}
